import { render, staticRenderFns } from "./one.vue?vue&type=template&id=1635c20f&scoped=true"
import script from "./one.vue?vue&type=script&lang=js"
export * from "./one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635c20f",
  null
  
)

export default component.exports